/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {OnDestroy} from '@angular/core';
import {Filter} from '../interfaces/filter';
import {FiltersProvider, RegisteredFilter} from '../providers/filters';
/**
 * @abstract
 */
export abstract class DatagridFilterRegistrar<F extends Filter<any>> implements OnDestroy {
/**
 * @param {?} filters
 */
constructor(private filters: FiltersProvider) {}
public registered: RegisteredFilter<F>;
/**
 * @return {?}
 */
public get filter(): F {
        return this.registered && this.registered.filter;
    }
/**
 * @param {?} filter
 * @return {?}
 */
public setFilter(filter: F|RegisteredFilter<F>) {
        // If we previously had another filter, we unregister it
        this.deleteFilter();
        if (filter instanceof RegisteredFilter) {
            this.registered = /** @type {?} */(( <RegisteredFilter<F>>filter));
        } else if (filter) {
            this.registered = this.filters.add( /** @type {?} */((<F>filter)));
        }
    }
/**
 * @return {?}
 */
public deleteFilter() {
        if (this.registered) {
            this.registered.unregister();
            delete this.registered;
        }
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
        this.deleteFilter();
    }
}

function DatagridFilterRegistrar_tsickle_Closure_declarations() {
/** @type {?} */
DatagridFilterRegistrar.prototype.registered;
/** @type {?} */
DatagridFilterRegistrar.prototype.filters;
}

